export class CloneTeamMember {
  static readonly type = '[Contract.TeamMember] Clone TeamMember';
  constructor(public partyID: number, public copies: number = 1) {}
}

export class DeleteTeamMember {
  static readonly type = '[Contract.TeamMember] Delete TeamMember';
  constructor(public partyID: number) {}
}

export class RestoreTeamMember {
  static readonly type = '[Contract.TeamMember] Restore TeamMember';
  constructor(public partyID: number) {}
}

export class AddTeamMember {
  static readonly type = '[Contract.TeamMember] Add TeamMember';
  constructor(public TeamMember: any) {}
}

export class UpdateTeamMember {
  static readonly type = '[Contract.TeamMember] Update TeamMember';
  constructor(public TeamMember: any) {}
}
